export class UsedCriteria {
  workspace: WorkspaceCriteria = new WorkspaceCriteria();
}

export class WorkspaceCriteria {
  contentSortIndex: number;
  viewType: string;
  contentFilterIndex: number;
}
